import { render } from "./HistorialPedidosView.vue?vue&type=template&id=a97b638a&scoped=true"
import script from "./HistorialPedidosView.vue?vue&type=script&lang=js"
export * from "./HistorialPedidosView.vue?vue&type=script&lang=js"

import "./HistorialPedidosView.vue?vue&type=style&index=0&id=a97b638a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97b638a"]])

export default __exports__